import $LoadingBar from './loading-bar';
var Loading = new $LoadingBar();
export default Loading;
